exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-icon-wrapper[data-v-dceea65c]{text-align:center;padding-top:20px}.header-icon-wrapper .v-icon[data-v-dceea65c]{font-size:5rem}.wrapper-title[data-v-dceea65c]{text-align:center;margin-top:5%;color:#3fa2f7}.wrapper-action[data-v-dceea65c]{text-align:center;padding:20px}.wrapper-action .v-btn[data-v-dceea65c]{width:90%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dceea65c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ProvisionsNotMetDialog.vue
// module id = 829
// module chunks = 0